import React, { Component } from 'react';

export default class FacebookRefresh extends Component {
	render() {
		return <>{window.FB && window.FB.XFBML && window.FB.XFBML.parse(document.getElementById('social-facebook'))}</>;
	}
}
